import { RouterModule, Routes } from '@angular/router';

import { AccountGuard } from './core/account.guard';
import { AuthGuard } from './core/auth.guard';
import { IdlePreload } from './core/idle-preload';
import { LocaleGuard } from './core/locale/locale.guard';
import { canActivatePortal } from './core/can-activate-portal';

const routes: Routes = [
  /* {
  path: '',
  canActivate: [AccountGuard, LocaleGuard],
  pathMatch: 'full',
  redirectTo: 'login'
} */
  { path: "", redirectTo: "login", pathMatch: 'full' },
  { path: "login", component: AccountGuard, canActivate: [AccountGuard, LocaleGuard, canActivatePortal] }
  , {
    path: 'account',
    loadChildren: () => import('./account/account.module').then(m => m.AccountModule),
    canActivate: [LocaleGuard, canActivatePortal]
  }, {
    path: 'translation-jobs',
    loadChildren: () => import('./translation-jobs/translation-jobs.module').then(m => m.TranslationJobsModule),
    canActivate: [AuthGuard, LocaleGuard, canActivatePortal]
  }, {
    path: 'people',
    loadChildren: () => import('./people/people.module').then(m => m.PeopleModule),
    canActivate: [AuthGuard, LocaleGuard, canActivatePortal]
  }, {
    path: 'no-access',
    loadChildren: () => import('./no-access/no-access.module').then(m => m.NoAccessModule),
    canActivate: [LocaleGuard]
  }];

export const AppRoutingModule = RouterModule.forRoot(routes, { preloadingStrategy: IdlePreload });
